<template><svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 59 59">
  <path fill="#e8e321"
        d="M0,0v59h44.13l14.87-15.17V0H0ZM29.36,39.23l-4.97,9.95-4.97-9.95-9.95-4.97,9.95-4.97,4.97-9.95,4.97,9.95,9.95,4.97-9.95,4.97ZM43.97,19.87l-2.6,5.21-2.6-5.21-5.21-2.6,5.21-2.6,2.6-5.2,2.6,5.2,5.21,2.6-5.21,2.6Z"/>
</svg></template>